var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"text-danger m-2 d-inline-block font-weight-lighter"},[_vm._t("default",function(){return [_vm._v("There was an unexpected error.")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }